import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlay } from "@fortawesome/free-solid-svg-icons";
import styles from "./styles.module.scss";
import { WelcomeContent, WelcomeVideo } from "./occasionalThemes";

interface Props {
  welcome: WelcomeContent;
  onClose: () => void;
}

// Motyw powitalny: komunikat + lista filmów instruktażowych (pogrupowana wg grup
// funkcji) + obszar odtwarzacza Vimeo, w którym otwiera się wybrany film.
const WelcomeTheme = ({ welcome, onClose }: Props) => {
  // Odtwarzacz domyślnie schowany — pojawia się dopiero po wybraniu filmu.
  const [selected, setSelected] = useState<WelcomeVideo | null>(null);

  return (
    <div className={styles.welcomeWrap} onClick={(e) => e.stopPropagation()}>
      <button className={styles.welcomeClose} title="Zamknij" onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} />
      </button>

      <div className={styles.welcomeHero}>
        <div className={styles.welcomeHeading}>{welcome.heading}</div>
        <div className={styles.welcomeIntro}>{welcome.intro}</div>
      </div>

      <div className={styles.welcomeMain}>
        {/* Lista filmów instruktażowych — filmy kolejno, w 2 kolumnach,
            do 3 wierszy widocznych (reszta przewijana). */}
        <div className={styles.welcomeList}>
          {welcome.videos.map((v) => (
            <button
              key={v.id}
              className={`${styles.welcomeVideo} ${
                selected?.id === v.id ? styles.welcomeVideoActive : ""
              }`}
              onClick={() => setSelected(v)}
            >
              <FontAwesomeIcon className={styles.welcomeVideoIcon} icon={faPlay} />
              <span className={styles.welcomeVideoTitle}>{v.title}</span>
              {v.duration && <span className={styles.welcomeVideoDur}>{v.duration}</span>}
            </button>
          ))}
        </div>

        {/* Odtwarzacz Vimeo — pojawia się dopiero po wybraniu filmu z listy. */}
        {selected && (
          <div className={styles.welcomePlayer}>
            <div className={styles.welcomePlayerFrame}>
              <iframe
                title={selected.title}
                src={`https://player.vimeo.com/video/${selected.vimeoId}`}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeTheme;
